import { formOptions } from '@tanstack/react-form'
import { z } from 'zod'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { withForm } from '@/lib/form'
import { microUSDCToDollars, USDCToString } from '@/lib/currency'

interface BuyInGameInfo {
  min_buy_in: number
  max_buy_in: number
}

export const buyInFormOpts = formOptions({
  defaultValues: {
    buyInAmount: '',
  },
})

export const BuyInForm = withForm({
  ...buyInFormOpts,
  props: {
    game: null as BuyInGameInfo | null,
    balance: 0,
    open: false,
    onOpenChange: (() => {}) as (open: boolean) => void,
  },
  render: ({ form, game, balance, open, onOpenChange }) => {
    if (!game) return null

    const minDollars = microUSDCToDollars(game.min_buy_in)
    const maxDollars = microUSDCToDollars(Math.min(game.max_buy_in, balance))
    const isFixedBuyIn = game.min_buy_in === game.max_buy_in

    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Buy In</DialogTitle>
            <DialogDescription>
              Choose a buy-in amount between ${minDollars.toFixed(2)} and $
              {maxDollars.toFixed(2)}
            </DialogDescription>
          </DialogHeader>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              form.handleSubmit()
            }}
          >
            <form.AppForm>
              <div className="flex flex-col gap-4">
                {isFixedBuyIn ? (
                  <p className="text-lg font-medium">
                    ${USDCToString(game.min_buy_in)}
                  </p>
                ) : (
                  <form.AppField
                    name="buyInAmount"
                    validators={{
                      onChange: z
                        .string()
                        .min(1, 'Amount is required')
                        .refine(
                          (val) => {
                            const num = parseFloat(val)
                            return !isNaN(num) && num >= minDollars
                          },
                          {
                            message: `Minimum buy-in is $${minDollars.toFixed(2)}`,
                          },
                        )
                        .refine(
                          (val) => {
                            const num = parseFloat(val)
                            return !isNaN(num) && num <= maxDollars
                          },
                          {
                            message: `Maximum is $${maxDollars.toFixed(2)}`,
                          },
                        ),
                    }}
                    children={(field) => (
                      <field.TextField
                        label="Buy-in Amount ($)"
                        htmlFor="buyInAmount"
                        placeholder={minDollars.toFixed(2)}
                        type="number"
                      />
                    )}
                  />
                )}
                <DialogFooter>
                  <form.SubmitButton label="Buy In" />
                </DialogFooter>
              </div>
            </form.AppForm>
          </form>
        </DialogContent>
      </Dialog>
    )
  },
})
